import { t } from '../../app/i18n';

export default {
  EMPLOYED_INDEFINITE: 'EMPLOYED_INDEFINITE',
  EMPLOYED_DEFINITE: 'EMPLOYED_DEFINITE',
  AGREEMENT_OTHER: 'AGREEMENT_OTHER',
  SELF_EMPLOYED: 'SELF_EMPLOYED',
  OWN_BUSINESS_INCOME: 'OWN_BUSINESS_INCOME',
  FOREIGN_INCOME: 'FOREIGN_INCOME',
  UNEMPLOYED: 'UNEMPLOYED',
  STUDENT: 'STUDENT',
  RETIRED: 'RETIRED',
  MATERNAL_LEAVE: 'MATERNAL_LEAVE',
  OTHER: 'OTHER',
};

export const translation = {
  EMPLOYED_INDEFINITE: t('Zamestnanie na dobu neurčitú'),
  EMPLOYED_DEFINITE: t('Zamestnanie na dobu určitú'),
  AGREEMENT_OTHER: t('Dohoda a iné typy pracovnej zmluvy'),
  SELF_EMPLOYED: t('Živnostník'),
  OWN_BUSINESS_INCOME: t('Príjmy z vlastnej firmy'),
  FOREIGN_INCOME: t('Príjmy zo zahraničia'),
  UNEMPLOYED: t('Nezamestnaný'),
  STUDENT: t('Študent'),
  RETIRED: t('Dôchodca'),
  MATERNAL_LEAVE: t('Žena na materskej'),
  OTHER: t('Iné'),
};



// WEBPACK FOOTER //
// ./src/common/enums/socialStatus.js